var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconListPlus = function SvgIconListPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 6a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1M2.75 12a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1M3.75 17a1 1 0 1 0 0 2h9.75a1 1 0 1 0 0-2zM16.25 18a1 1 0 0 1 1-1h1.25v-1.25a1 1 0 1 1 2 0V17h1.25a1 1 0 1 1 0 2H20.5v1.25a1 1 0 1 1-2 0V19h-1.25a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconListPlus;